import { TEST_IDS } from '@va/constants';
import { ArrowLeft, ArrowRight } from '@va/svg-visa-icons';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useDateInputContext } from './DateInputContext';
import { PickerButton } from './PickerButton';
import { DateInputView } from './types';

export const CalendarHeader = () => {
  const {
    pickerViewState: { year, month, view, canShowNext, canShowPrev },
    setView,
    showNextMonth,
    showPrevMonth,
    showNextYears,
    showPrevYears,
  } = useDateInputContext();

  const handlePrevClick = useCallback(() => {
    if (view === DateInputView.Year) {
      showPrevYears();
      return;
    }

    showPrevMonth();
  }, [showPrevMonth, showPrevYears, view]);

  const handleNextClick = useCallback(() => {
    if (view === DateInputView.Year) {
      showNextYears();
      return;
    }

    showNextMonth();
  }, [showNextMonth, showNextYears, view]);

  const handleYearClick = useCallback(() => {
    if (view === DateInputView.Year) {
      setView(DateInputView.Day);
      return;
    }

    setView(DateInputView.Year);
  }, [setView, view]);

  const handleMonthClick = useCallback(() => {
    if (view === DateInputView.Month) {
      setView(DateInputView.Day);
      return;
    }

    setView(DateInputView.Month);
  }, [setView, view]);

  return (
    <div
      className='flex justify-between items-center px-2 py-1.5 rounded-md border border-black/10 dark:border-primary-700'
      data-testid={TEST_IDS.generic.datePicker.header}
    >
      <PickerButton
        onClick={handlePrevClick}
        data-testid={TEST_IDS.generic.buttons.back}
        className={classNames('!rounded-full !p-1.5', {
          hidden: view === DateInputView.Month,
        })}
        disabled={!canShowPrev}
      >
        <ArrowLeft className='w-5 h-5' />
      </PickerButton>
      <div className='px-1.5 gap-1.5 flex flex-1'>
        <PickerButton className='flex-1' data-testid={TEST_IDS.generic.buttons.select} onClick={handleMonthClick}>
          {dayjs().month(month).format('MMM')}
        </PickerButton>
        <PickerButton className='flex-1' data-testid={TEST_IDS.generic.buttons.select} onClick={handleYearClick}>
          {year}
        </PickerButton>
      </div>
      <PickerButton
        onClick={handleNextClick}
        data-testid={TEST_IDS.generic.buttons.next}
        className={classNames('!rounded-full !p-1.5', {
          hidden: view === DateInputView.Month,
        })}
        disabled={!canShowNext}
      >
        <ArrowRight className='w-5 h-5' />
      </PickerButton>
    </div>
  );
};
